module.exports = __webpack_public_path__ + "img/mortgage.1d33f5ad.svg";